import React from "react";
import DocList from "../../_components/Purchasing/PurchaseDocList";
import { FiFileText, FiClock, FiCheckCircle, FiXCircle, FiUser, FiDollarSign, FiHome } from "react-icons/fi";
import { T, fmtMYR } from "../../_components/Purchasing/PurchaseShared";
import {
    getPurchaseDebitNotes,
    getPurchaseDebitNoteKpis,
    deletePurchaseDebitNote
} from "../../_services/finance.service";

export default function PurchaseDebitNotes() {
    return (
        <DocList
            docType="Purchase Debit Note"
            basePath="/finance/purchase-debit-notes"
            fetchList={getPurchaseDebitNotes}
            fetchKpis={getPurchaseDebitNoteKpis}
            deleteItem={deletePurchaseDebitNote}
            statuses={["All", "Draft", "Pending for Approval", "Approved", "Rejected"]}
            kpiCards={[
                { label: "Total", key: "total", icon: FiFileText, color: T.accent },
                { label: "Pending", key: "pending", icon: FiClock, color: T.warning },
                { label: "Approved", key: "approved", icon: FiCheckCircle, color: T.success },
                { label: "Rejected", key: "rejected", icon: FiXCircle, color: T.danger },
            ]}
            previewFields={[
                { icon: FiClock, label: "Date", key: "date" },
                { icon: FiHome, label: "Supplier", key: "supplier" },
                { icon: FiUser, label: "Contact Person", key: "contactPerson" },
                { icon: FiDollarSign, label: "Grand Total", key: "grandTotal", render: (v) => fmtMYR(v) },
            ]}
            searchOptions={[
                { key: "all", label: "All" },
                { key: "id", label: "CN No." },
                { key: "date", label: "Date" },
                { key: "supplier", label: "Company Name" },
                { key: "contactPerson", label: "Contact Person" },
            ]}
        />
    );
}